import React from "react"
import PropTypes from "prop-types"
import { FormGroup, Input, ImageUploader } from "@tencent/spaui"
import { withApi } from "@tencent/react-aio"
import Dialog from "@/components/Dialog"
import BatchReleaseBlackList from "../usercenter/BatchReleaseBlackList"
import Delegate from "@/components/Delegate"
import MessageBox from "@/components/MessageBox"
import _ from "lodash"
import EmployeeTeamSelect from "@/business-components/sale/EmployeeTeamSelect"
import CreateOrderContractMethodSelect from "@/components/CreateOrderContractMethodSelect"
import OrderingProductSelect from '@/business-components/sale/OrderingProductSelect';

class EditOrderModal extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    order: PropTypes.object,
    lead: PropTypes.number,
    onSubmit: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    if (props) {
      const {
        orderId,
        firstPaymentAmount,
        serviceFee,
        contractMethod,
        orderingProductIds,
        version,
        leadId,
        AgencyId,
        remittanceVoucherAttachmentList,
        ownerTeamIdWhenPaymentConfirmed,
        contractVoucherAttachmentList,
        remittanceAccount,
        remittanceAccountName,
        remittanceVoucherAttachmentIds,
        contractNo,
        contractVoucherAttachmentIds,
      } = props.orderInfo

      this.state = {
        leadId,
        AgencyId,
        version,
        orderId,
        firstPaymentAmount,
        serviceFee,
        contractMethod,
        orderingProductIds: orderingProductIds,
        remittanceAccount,
        remittanceAccountName,
        contractNo,
        remittanceVoucherAttachmentList,
        contractVoucherAttachmentList,
        ownerTeamIdWhenPaymentConfirmed,
        contractVoucherAttachmentIds: contractVoucherAttachmentIds != null ? contractVoucherAttachmentIds.values : [],
        remittanceVoucherAttachmentIds: remittanceVoucherAttachmentIds != null ? remittanceVoucherAttachmentIds.values : [],
        leadVersion: version,
        contractImages: [],
        remittanceImages: [],
      }
    }
    this.handleContractComplete = this.handleContractComplete.bind(this)
    this.handleContractDelete = this.handleContractDelete.bind(this)

    this.handleRemittanceComplete = this.handleRemittanceComplete.bind(this)
    this.handleRemittanceDelete = this.handleRemittanceDelete.bind(this)
  }
  setRemittanceImages(remittanceVoucherAttachmentList) {
    const remittanceImages = remittanceVoucherAttachmentList.map((a) => {
      return {
        url: a.contentType && a.contentType.startsWith("image/") ? a.url : undefined,
        name: a.attachmentName,
        id: a.attachmentId,
      }
    })
    this.setState({
      remittanceImages: remittanceImages,
    })
  }
  setContractImages(contractVoucherAttachmentList) {
    const contractImages = contractVoucherAttachmentList.map((a) => {
      return {
        url: a.contentType && a.contentType.startsWith("image/") ? a.url : undefined,
        name: a.attachmentName,
        id: a.attachmentId,
      }
    })
    this.setState({
      contractImages: contractImages,
    })
  }

  componentDidMount() {
    const { remittanceVoucherAttachmentList, contractVoucherAttachmentList } = this.state
    if (remittanceVoucherAttachmentList) this.setRemittanceImages(remittanceVoucherAttachmentList)
    if (contractVoucherAttachmentList) this.setContractImages(contractVoucherAttachmentList)
  }

  render() {
    const { ownerId } = this.props.orderInfo
    const { ownerTeamIdWhenPaymentConfirmed, remittanceImages, contractImages, remittanceAccount, remittanceAccountName, contractNo, submitting, error } = this.state
    const {
      firstPaymentAmount,
      serviceFee,
      contractMethod,
      orderingProductIds,
      contractUploadHelpBlock,
      contractUploadStatus,
      remittanceUploadStatus,
      remittanceUploadHelpBlock,
    } = this.state;

    let remittanceUploadHelpBlock2 = (
      <div>
        文件最大支持1M <br />
        必备内容：1、到/打款时间 2、服务商公司名称 3、打款金额/公司名称（须与CRM系统内保持一致）
        <br />
        凭证规范：1、凭证完整，字迹清晰 2、线上支付须为支付成功后的截图 3、线下凭证须含有效盖章（银行/服务商）
      </div>
    )

    return (
      <Dialog className="CreateOrderModal" title="编辑订单信息" {...this.props} style={{ width: 640 }} submitLabel={"确定并提交审核"} onSubmit={this.handleSubmit} disabled={submitting}>
        <fieldset>
          <legend>提单信息</legend>
          <FormGroup className={"required with-select"} feedback={"元"} helpBlock={"请确认是否已到款，提交后将无法修改此商机"}>
            <label htmlFor={"firstPaymentAmount"}>首次到款金额：</label>
            <Input id={"firstPaymentAmount"} type={"number"} value={firstPaymentAmount} onChange={this.handleChangeFirstPaymentAmount} />
          </FormGroup>
          <FormGroup className={"required with-select"} feedback={"元"}>
            <label htmlFor={"serviceFee"}>服务费：</label>
            <Input id={"serviceFee"} type={"number"} value={serviceFee} onChange={this.handleChangeServiceFee} />
          </FormGroup>
          <FormGroup feedback={"元"} helpBlock="充值至客户投放平台金额，由系统自动计算">
            <label htmlFor={"adFee"}>广告费：</label>
            <Input id={"adFee"} type={"number"} disabled value={firstPaymentAmount - serviceFee} />
          </FormGroup>
          <FormGroup className="required with-select">
            <label>成单方式：</label>
            <CreateOrderContractMethodSelect
              value={contractMethod}
              onChange={this.handleChangeContractMethod}
              onClear={(event, value) => {
                this.handleChangeContractMethod(event, undefined)
              }}
            />
          </FormGroup>
          <FormGroup className="required with-select">
            <label>下单产品：</label>
            <OrderingProductSelect
              value={orderingProductIds}
              onChange={this.handleOrderingProductSelect}
              onClear={(event, value) => {
                this.handleOrderingProductSelect(event, undefined)
              }}
            />
          </FormGroup>
          <FormGroup className="required with-select">
            <label>订单所属团队：</label>
            <EmployeeTeamSelect value={ownerTeamIdWhenPaymentConfirmed} ownerId={ownerId} setTeamId={this.setTeamId} onChange={this.handleChangeTeamId} />
          </FormGroup>
          <legend>财务信息</legend>
          <FormGroup>
            <label>汇款帐号：</label>
            <Input id={"remittanceAccount"} value={remittanceAccount} onChange={this.handleChangeRemittanceAccount} />
          </FormGroup>
          <FormGroup>
            <label>汇款账户名：</label>
            <Input id={"remittanceAccountName"} value={remittanceAccountName} onChange={this.handleChangeRemittanceAccountName} />
          </FormGroup>
          <FormGroup className="required" status={remittanceUploadStatus} helpBlock={remittanceUploadHelpBlock ? remittanceUploadHelpBlock : remittanceUploadHelpBlock2}>
            <label>汇款凭证：</label>
            <ImageUploader upload={true} drag={false} reupload={false} count={3} name="image" url="/ags/attachment/upload" multiple={true} value={remittanceImages} filter={this.checkRemittanceFile} onComplete={this.handleRemittanceComplete} onDelete={this.handleRemittanceDelete} />
          </FormGroup>
          <legend>合同信息</legend>
          <FormGroup>
            <label>合同编号：</label>
            <Input id={"contractNo"} value={contractNo} onChange={this.handleChangeContractNo} />
          </FormGroup>
          <FormGroup status={contractUploadStatus} helpBlock={contractUploadHelpBlock ? contractUploadHelpBlock : "文件最大支持1M"}>
            <label>合同凭证：</label>
            <ImageUploader upload={true} drag={false} reupload={false} count={3} name="image" url="/ags/attachment/upload" multiple={true} value={contractImages} filter={this.checkContractFile} onComplete={this.handleContractComplete} onDelete={this.handleContractDelete} />
          </FormGroup>
        </fieldset>

        {error && (
          <p className={"has-error"}>
            <span className={"error-message"}>发生错误：{error.message || "服务器错误"}</span>
          </p>
        )}
      </Dialog>
    )
  }

  checkRemittanceFile = (fileInfo, event) => {
    if (fileInfo && fileInfo.size) {
      if (fileInfo.size > 1024 * 1024) {
        this.setState({
          remittanceUploadHelpBlock: "文件大小超过1M",
          remittanceUploadStatus: "error",
        })
        return false
      }
    }
    return true
  }

  handleChangeRemittanceAccount = (e, value) => {
    this.setState({
      remittanceAccount: e.target.value,
    })
  }

  handleChangeRemittanceAccountName = (e, value) => {
    this.setState({
      remittanceAccountName: e.target.value,
    })
  }

  handleChangeContractNo = (e, value) => {
    this.setState({
      contractNo: e.target.value,
    })
  }

  handleRemittanceDelete(event, value) {
    let images = _.cloneDeep(this.state.remittanceImages)
    images = _.filter(images, (image) => image.id !== value.id)
    this.setState({
      remittanceImages: images,
      remittanceVoucherAttachmentIds: _.map(images, (image, i) => image.id.toString()) || [],
    })
  }

  handleRemittanceComplete(response, fileTarget, fileId, xhr) {
    if (!_.isEmpty(response)) {
      let images = _.cloneDeep(this.state.remittanceImages)
      images = _.concat(images, {
        url: response.contentType && response.contentType.startsWith("image/") ? response.url : undefined,
        name: response.attachmentName,
        id: response.attachmentId,
      })
      this.setState({
        remittanceImages: images,
        remittanceVoucherAttachmentIds: _.map(images, (image, i) => image.id.toString()) || [],
        remittanceUploadHelpBlock: undefined,
        remittanceUploadStatus: "success",
      })
    } else {
      // 解析调用异常
      let name = fileTarget.name || "placehold"
      if (xhr && xhr.response) {
        let errorRes = JSON.parse(xhr.response)
        if (errorRes.error) {
          name += "上传失败：" + errorRes.error.message
        }
      }
      this.setState({
        remittanceUploadHelpBlock: name,
        remittanceUploadStatus: "error",
      })
    }
  }

  handleChangeTeamId = (e, value) => {
    this.setState({
      ownerTeamIdWhenPaymentConfirmed: value,
    })
  }

  setTeamId = (value) => {
    this.setState({
      ownerTeamIdWhenPaymentConfirmed: value,
    })
  }

  handleContractDelete(event, value) {
    let images = _.cloneDeep(this.state.contractImages)
    images = _.filter(images, (image) => image.id !== value.id)
    this.setState({
      contractImages: images,
      contractVoucherAttachmentIds: _.map(images, (image, i) => image.id.toString()) || [],
    })
  }

  checkContractFile = (fileInfo, event) => {
    if (fileInfo && fileInfo.size) {
      if (fileInfo.size > 1024 * 1024) {
        this.setState({
          contractUploadHelpBlock: "文件大小超过1M",
          contractUploadStatus: "error",
        })
        return false
      }
    }
    return true
  }

  handleContractComplete(response, fileTarget, fileId, xhr) {
    if (!_.isEmpty(response)) {
      let images = _.cloneDeep(this.state.contractImages)
      images = _.concat(images, {
        url: response.contentType && response.contentType.startsWith("image/") ? response.url : undefined,
        name: response.attachmentName,
        id: response.attachmentId,
        href: response.url,
      })
      this.setState({
        contractImages: images,
        contractVoucherAttachmentIds: _.map(images, (image, i) => image.id.toString()) || [],
        contractUploadHelpBlock: undefined,
        contractUploadStatus: "success",
      })
    } else {
      // 解析调用异常
      let name = fileTarget.name || "placehold"
      if (xhr && xhr.response) {
        let errorRes = JSON.parse(xhr.response)
        if (errorRes.error) {
          name += "上传失败：" + errorRes.error.message
        }
      }
      this.setState({
        contractUploadHelpBlock: name,
        contractUploadStatus: "error",
      })
    }
  }

  handleChangeFirstPaymentAmount = (e, value) => {
    this.setState({
      firstPaymentAmount: value,
      error: undefined,
    })
  }

  handleChangeServiceFee = (e, value) => {
    this.setState({
      serviceFee: value,
      error: undefined,
    })
  }

  handleChangeContractMethod = (event, value) => {
    this.setState({ contractMethod: value })
  }

  handleOrderingProductSelect = (event, value) => {
    this.setState({ orderingProductIds: value })
  }

  handleSubmit = () => {
    const {
      orderId,
      leadId,
      agencyId,
      version,
      remittanceAccount,
      remittanceAccountName,
      remittanceVoucherAttachmentIds,
      contractNo,
      contractVoucherAttachmentIds,
      firstPaymentAmount,
      serviceFee,
      contractMethod,
      orderingProductIds,
      ownerTeamIdWhenPaymentConfirmed,
      remittanceUploadStatus,
      remittanceImages,
    } = this.state;
    const { webApi, onSubmit } = this.props

    // 数据校验
    if (!firstPaymentAmount || firstPaymentAmount <= 0) {
      console.debug("invalid firstPaymentAmount: " + firstPaymentAmount)
      this.setState({
        error: {
          message: "首次提单金额必填",
        },
      })
      return
    }
    if (!serviceFee || serviceFee < 0) {
      console.debug("invalid serviceFee: " + serviceFee)
      this.setState({
        error: {
          message: "服务费必填",
        },
      })
      return
    }

    if (!contractMethod) {
      this.setState({
        error: {
          message: "成单方式必填",
        },
      })
      return
    }
    if (!orderingProductIds || orderingProductIds?.length === 0) {
      this.setState({
        error: {
          message: "下单产品必填",
        },
      })
      return
    }

    if (!ownerTeamIdWhenPaymentConfirmed) {
      this.setState({
        error: {
          message: "订单所属团队必填",
        },
      })
      return
    }

    console.log("remittanceUploadStatus - ", remittanceUploadStatus, remittanceImages)
    if (remittanceImages.length === 0) {
      this.setState({
        error: {
          message: "汇款凭证必填",
        },
      })
      return
    }

    this.setState({
      submitting: true,
      error: undefined,
    })

    webApi
      .updateOrder(leadId)
      .ajaxJson({
        data: {
          agencyId,
          orderId,
          leadId,
          remittanceAccount,
          remittanceAccountName,
          contractNo,
          ownerTeamIdWhenPaymentConfirmed,
          leadVersion: parseInt(version),
          firstPaymentAmount: parseFloat(firstPaymentAmount),
          serviceFee: parseFloat(serviceFee),
          contractMethod,
          orderingProductIds,
          remittanceVoucherAttachmentIds: {
            values: remittanceVoucherAttachmentIds || [],
          },
          contractVoucherAttachmentIds: {
            values: contractVoucherAttachmentIds || [],
          },
        },
      })
      .then(
        (res) => {
          this.context.success("编辑订单成功")
          this.setState({
            submitting: false,
          })
          onSubmit()
          this.props.refreshTable()
        },
        (error) => {
          this.context.error("编辑订单失败", error.message)
          this.setState({
            submitting: false,
            error,
          })
        }
      )
  }
}

export default EditOrderModal

EditOrderModal.contextType = MessageBox
